export default __webpack_public_path__ + "static/ai-waves-e98f229431f5d91a7210026baf726bb4.webp";